module.exports = __webpack_public_path__ + "img/loginlogo.147b9d6f.png";